import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/stock/warehouseArea";

/**
 * 路桥定制-堆料区（货区）
 *
 * 一个仓库对应多个堆料区，堆料区二维码扫码后在小程序里按货区选商品出库。
 */
export default {
    /** 分页查询 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 全部堆料区（不分页，仓库为空查全部） */
    queryAll: (warehouseId) => axios.get({url: `${PREFIX_URI}/queryAll`, data: warehouseId ? {warehouseId} : {}}),
    /** 详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 新增/编辑 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 删除 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 生成小程序二维码（已有的跳过） */
    updateQrCode: (ids) => axios.post({url: `${PREFIX_URI}/updateQrCode`, data: ids}),
}
